import React from "react";
import classes from "./aboutus.module.scss";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const AboutPage = () => {
  const navigate = useNavigate();
  return (
    <div className={classes.wrapper}>
      <div className={classes.about}>
        <div className="container">
          <h4>ABOUT US</h4>
          <h2>Built for performance. Trusted for decades.</h2>
          <div className={classes.about__des}>
            <p>
              At MIFAB, we design smarter solutions for real-world drainage
              challenges. With over 40 years of experience in the industry, our
              mission is simple: to deliver products that perform reliably,
              simplify installation, and meet the strictest compliance standards
              across North America.
            </p>
            <p>
              From high-efficiency grease and oil interceptors to advanced
              drainage systems, our products are engineered to support
              commercial kitchens, institutional facilities, industrial
              environments, and everything in between.
            </p>
          </div>
        </div>
      </div>

      <div className={classes.trusted}>
        <div className="container">
          <div className={classes.trusted__row}>
            <div className={classes.trusted__text}>
              <h4>
                Trusted in every <br />
                kitchen that counts
              </h4>
              <h2>Serving the industries that keep communities running</h2>
              <p>
                MIFAB products are trusted across a wide range of applications:
                restaurants, schools, hospitals, grocery stores, shared
                kitchens, food processors, and more.
              </p>
              {/* <button type="button" className={classes.btn}>
                See Full List of Applications
                <span>
                  <IoIosArrowForward />
                </span>
              </button> */}
            </div>
            <div className={classes.trusted__img}>
              <img src="/images/trusted-img2.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className={classes.getStart}>
        <div className="container">
          <div className={classes.getStart__row}>
            <div>
              <h2>Ready to get started?</h2>
            </div>
            <div>
              <p>
                Need support on a multi-site rollout or a custom install? Our
                team is here to help.
              </p>
              <button
                type="button"
                className={`${classes.btn} ${classes.btn__light}`}
                onClick={() => navigate("/contact")}
              >
                Contact Us
                <span>
                  <IoIosArrowForward />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
